import { render, staticRenderFns } from "./SuccessDonateMoney.vue?vue&type=template&id=3846da24&"
import script from "./SuccessDonateMoney.vue?vue&type=script&lang=js&"
export * from "./SuccessDonateMoney.vue?vue&type=script&lang=js&"
import style0 from "./SuccessDonateMoney.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports